import React from 'react';
import { Edit } from 'react-feather';

const EditProfileButton = (props: { handleClick: () => void }) => {
  const { handleClick } = props;

  return (
    <div
      className="flex absolute cursor-pointer items-center right-5 top-4"
      onClick={handleClick}
    >
      <Edit className="text-white lg:text-neutral-700" size={18} />
      <p className="ml-2 text-white lg:text-neutral-700">Edit profile</p>
    </div>
  );
};

export default EditProfileButton;
